import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface AssignTransportRequestApiVariables {
  regionId: string
  teamId: string
  transportRequestId: string
}

export const useAssignTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, AssignTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, AssignTransportRequestApiVariables>({
    type: 'piloteAssignTransportRequest',
    ...options,
  })
